import { useEffect } from "react";
import { API_BASE, clearAuthSession } from "../utils/authSession";

const DASHBOARDS = {
  admin: "/admin/dashboard",
  supervisor: "/supervisor/dashboard",
  advisor: "/advisor/dashboard",
  supporter: "/supporter/dashboard",
  student: "/student-dashboard",
  guest: "/guest/dashboard",
  parent: "/parent/dashboard",
  question_designer: "/question-designer/dashboard",
};

export default function PersistentSession() {
  useEffect(() => {
    let active = true;
    let refreshing = false;
    const refresh = async () => {
      const token = localStorage.getItem("token");
      const savedRole = localStorage.getItem("role");
      if (!token || !savedRole || refreshing) return;
      refreshing = true;
      try {
        const response = await fetch(`${API_BASE}/auth/session/refresh`, {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
          cache: "no-store",
        });
        if (!active) return;
        if (!response.ok) {
          if (response.status === 401 || response.status === 403) clearAuthSession();
          return;
        }
        const data = await response.json();
        if (data.role !== savedRole) {
          clearAuthSession();
          return;
        }
        if (["/", "/auth/login"].includes(window.location.pathname)) {
          window.location.replace(DASHBOARDS[data.role] || "/auth/login");
        }
      } catch (_) {
        // Offline users keep their local session and retry when connectivity returns.
      } finally {
        refreshing = false;
      }
    };
    const onVisible = () => { if (document.visibilityState === "visible") refresh(); };
    refresh();
    const timer = window.setInterval(refresh, 6 * 60 * 60 * 1000);
    window.addEventListener("online", refresh);
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      active = false;
      window.clearInterval(timer);
      window.removeEventListener("online", refresh);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);
  return null;
}
